export default __webpack_public_path__ + "static/media/camion.e93877b2.png";